import React from 'react';
import { Chip } from '@mui/material';
import { DataTypeProvider } from '@devexpress/dx-react-grid';

const CarFormatter = ({ row }) => {
  const brand = row.car_brand || '';
  const model = row.car_model || '';
  const engine = row.car_engine_code ? `[${row.car_engine_code}]` : '';
  const notes = row.car_notes && row.car_notes.trim() !== '' ? row.car_notes : null;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
      <span>
        {brand} {model} {engine && <span style={{ color: '#888' }}>{engine}</span>}
      </span>
      {notes && (
        <span style={{ fontSize: '0.85em', color: '#888', marginTop: 2 }}>{notes}</span>
      )}
    </div>
  );
};
const CarTypeProvider = props => <DataTypeProvider formatterComponent={CarFormatter} {...props} />

export default CarTypeProvider;
